import {ImportModuleConceptTerm} from '../../../core/definitions/import-module';

/**
 * One option in an Import module concept picker (the generic batch card,
 * a group-card header, a sub-block header).
 *
 * For a hierarchic concept list (e.g. `history_event_type_id`) an option
 * also carries `leaf_name`, `level` and `path`: `name` is the indexed
 * display name, which for a hierarchic concept is the full delimited path
 * (`Produksjon\Bearbeidet`), so a picker shows `leaf_name` (`Bearbeidet`)
 * with `path` - the *ancestor* trail only, already joined with " › " and
 * empty for a root (`Produksjon › Støpt`) - shown under the field to
 * disambiguate same-named concepts under different parents. `level` is
 * the concept's 1-based depth (1 = root).
 *
 * `has_authority` marks a term that comes from KulturNav; a picker shows
 * the blue authority dot after its name.
 */
export type ConceptOption = ImportModuleConceptTerm;

/** What a picker shows for an option / a picked value - the leaf name for
 * a hierarchic concept, the plain name otherwise. */
export function conceptOptionLabel(option: ConceptOption | undefined): string {
  return option ? (option.leaf_name || option.name) : '';
}

/** The ancestor breadcrumb to show under the field, or `''` when there is
 * none (a flat concept, or a hierarchic root). */
export function conceptOptionAncestors(option: ConceptOption | undefined): string {
  return option?.path ?? '';
}
